import React from 'react';
import { Container } from 'react-bootstrap';
import styles from './AdminPage.module.scss';
import DashboardButtonsCard from '../components/DashboardButtonsCard';
import { useNavigate } from 'react-router-dom';

type AdminPageProps = {
  user: User | null;
};

const AdminPage: React.FC<AdminPageProps> = ({ user }) => {
  const navigate = useNavigate();

  return (
    <Container className="center">
      <h2 className={styles["title"]}>Administração</h2>
      <DashboardButtonsCard
        welcomeMessage="Usuários"
        buttons={[
          { text: 'Gerenciar usuários', onClick: () => navigate('/admin/accounts') },
        ]}
      />
    </Container>
  );
};

export default AdminPage;
